import React, { useState, useEffect } from 'react';
import { Typography, Row, Col, Card, Spin, Alert, Input } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { getCategories } from '../services/categoriesService';

const { Title, Text } = Typography;
const { Search } = Input;
function CategoryCard({ category }) {
  return (
    <Card
      cover={
        <div style={{ position: 'relative' }}>
          <img
            alt={category.name}
            src={
              category.teaser_image_url ||
              category.image_url ||
              'https://source.unsplash.com/random?category'
            }
            style={{ height: 200, width: '100%', objectFit: 'cover' }}
          />
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
              padding: '20px',
              color: 'white',
            }}
          >
            <Typography.Title level={5} style={{ color: 'white', margin: 0 }}>
              {category.name}
            </Typography.Title>
            {category.show_card_text && (
              <Typography.Text style={{ color: 'white' }}>{category.description}</Typography.Text>
            )}
          </div>
        </div>
      }
      bodyStyle={{ display: 'none' }}
      style={{
        height: '200px',
        cursor: 'pointer',
      }}
      onClick={() => window.open(`/places/embed?category=${category.id}`, '_blank')}
    />
  );
}

function CategoriesEmbed() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get('category');

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategories();
        if (categoryId) {
          setCategories(data.filter(cat => cat.id === categoryId));
        } else {
          setCategories(data);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [categoryId]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '24px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '24px' }}>
        <Alert message={error} type="error" />
      </div>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <Search
        placeholder="Search categories..."
        onChange={e => {
          const value = e.target.value.toLowerCase();
          const filtered = categories.filter(
            category =>
              category.name.toLowerCase().includes(value) ||
              category.description?.toLowerCase().includes(value)
          );
          setCategories(filtered);
        }}
        style={{ marginBottom: 24 }}
      />
      <Row gutter={[16, 16]}>
        {categories.map(category => (
          <Col key={category.id} xs={24} sm={12} md={8} lg={6}>
            <CategoryCard category={category} />
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default CategoriesEmbed;
